export default {
  namespaced: true,
  mutations: {
    // toggleParallax
  },
  getters: {
    elements: (state, getters, rootState, rootGetters) => (element = new Object) => {
        let sections = rootGetters['pageModule/sections']
        return Object.prototype.hasOwnProperty.call(element, 'section') ? sections[element.section] : sections
    },
    index: (state, getters) => id => getters.elements().findIndex(section => section.id == id),
    id: (state, getters) => element =>  getters.elements(element).id,
    name: (state, getters) => element => getters.elements(element).name,
    styles: (state, getters) => (element, styles = 'styles') => getters.elements(element)[styles],
    classes: (state, getters) => (element, classes = 'classes') => getters.elements(element)[classes],
    assets: (state, getters) => element => getters.elements(element).assets,
    properties: (state, getters) => element => getters.elements(element).properties,
    background: (state, getters) => element =>  getters.elements(element).background,
  },
  actions: {
    updateOrder({commit}, payload) {
        payload = {...payload, module: 'sectionModule'}
        commit('actionsModule/updateElementsOrder', payload, {root: true})
    }, 
    addToArray({commit}, payload) {
        payload = {...payload, module: 'sectionModule'}
        commit('actionsModule/addToArray', payload, {root: true})
    },
    removeFromArray({commit}, payload) {
        payload = {...payload, module: 'sectionModule'}
        commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
        payload = {...payload, module: 'sectionModule'}
        commit('actionsModule/addToObject', payload, {root: true})
    },
  }
}